"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILTextField = void 0;
var react_1 = __importDefault(require("react"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var enums_1 = require("../../shared/enums");
var ILTextField = function (props) {
    return (react_1.default.createElement(TextField_1.default, __assign({ placeholder: 'Name of School Year',
        hiddenLabel: true,
        disabled: false,
        size: enums_1.SizeEnum.SMALL,
        variant: enums_1.TextFieldVariantEnum.OUTLINED,
        color: enums_1.ColorPaletteEnum.PRIMARY,
        error: false }, props), props.children));
};
exports.ILTextField = ILTextField;
